import { render, staticRenderFns } from "./EventStormingTextElement.vue?vue&type=template&id=655b9105&scoped=true&"
import script from "./EventStormingTextElement.vue?vue&type=script&lang=js&"
export * from "./EventStormingTextElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b9105",
  null
  
)

export default component.exports